import { Button, Stack, Typography } from "@mui/material";
import Logo from "./Logo";

const FullPageMessage = ({ title, description, actionLabel, onAction }) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    spacing={2}
    textAlign="center"
    sx={{ minHeight: "100vh", px: 2 }}
  >
    <Logo />
    <Typography variant="h5" sx={{ color: "primary.main", fontWeight: 600 }}>
      {title}
    </Typography>
    <Typography color="text.secondary">{description}</Typography>
    <Button variant="contained" onClick={onAction}>
      {actionLabel}
    </Button>
  </Stack>
);

export default FullPageMessage;
